<template>
  <div class="template4">
    <!-- 主内容区 -->
    <div class="t4-content">

      <!-- 中间内容图片 -->
      <div class="t4-middle-image">
        <img :src="middleImgUrl" class="middle-img" alt="" />
      </div>

      <!-- 底部推荐图横向滑动 -->
      <div class="t4-recommend" v-if="recommendList.length > 0" ref="recommendWrap">
        <div class="t4-recommend-inner" ref="recommendInner">
          <div
            v-for="(item, index) in recommendList"
            :key="index"
            class="t4-recommend-item"
            :ref="'recItem' + index"
            :class="{ 't4-recommend-active': item.activityId === String(activityData.id) }"
            @click="goRecommend(item)"
          >
            <img :src="item.image" class="t4-recommend-img" alt="" />
            <div class="t4-recommend-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹框 -->
    <div class="popup-overlay" v-if="showPopup" @click.self="closePopup">
      <div class="popup-content">
        <div class="popup-close" @click="closePopup">
          <img src="/static/image/event/close_popup.png" alt="关闭" />
        </div>
        <div class="popup-body">
          <img :src="popupItem.image" class="popup-img" alt="" />
          <div class="popup-name">{{ popupItem.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { recommendList } from './activityConfig';

export default {
  name: 'template4',
  props: {
    activityData: {
      type: Object,
      default: () => ({}),
    },
    from: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showPopup: false,
      popupItem: null,
      recommendList,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollToActive();
    });
  },
  computed: {
    middleImgUrl() {
      const id = this.activityData.id;
      if (id === '72' || !id) {
        return '/static/newImg/active/template/2078445455277834242.avif';
      }
      return `/static/newImg/active/template/template4_${id}_01.avif`;
    },
  },
  methods: {
    goRecommend(item) {
      if (item.popup === 1) {
        this.popupItem = item;
        this.showPopup = true;
      } else if (item.url_open === 1 && item.url) {
        window.location.href = item.url;
      } else if (item.jump) {
        this.$router.replace(`/activityDetail?template=${item.templateId}&activity_id=${item.activityId}&from=recommend`);
      }
    },
    closePopup() {
      this.showPopup = false;
      this.popupItem = null;
    },
    scrollToActive() {
      const activeIndex = this.recommendList.findIndex(item => item.activityId === String(this.activityData.id));
      if (activeIndex === -1) return;

      const wrap = this.$refs.recommendWrap;
      const items = this.$refs['recItem' + activeIndex];
      if (!wrap || !items || !items[0]) return;

      const itemEl = items[0];
      const wrapWidth = wrap.offsetWidth;
      const itemLeft = itemEl.offsetLeft;
      const itemWidth = itemEl.offsetWidth;

      const scrollLeft = itemLeft - (wrapWidth / 2) + (itemWidth / 2);
      wrap.scrollTo({ left: Math.max(0, scrollLeft), behavior: 'smooth' });
    },
  },
};
</script>

<style lang="scss" scoped>
.template4 {
  background: #0a0a0a;
  min-height: 100vh;
}

.t4-content {
  padding: 0.2rem;
}

.t4-top-banner {
  margin-bottom: 0.3rem;
  background: #0a0a0a;
  padding: 0;

  .top-banner-img {
    width: 100%;
    display: block;
  }
}

// 中间内容图片
.t4-middle-image {
  margin-bottom: 0.3rem;
  background: #0a0a0a;
  padding: 1rem 0.5rem;

  .middle-img {
    width: 100%;
    height: auto;
    display: block;
  }
}

// 卡片基础样式
.t4-card {
  background: #0a0a0a;
  border-radius: 0.1rem;
  padding: 0.2rem;
  margin-bottom: 0.2rem;

  .card-title-icon {
    width: 1.5rem;
    height: auto;
    display: block;
    margin: 0 auto 0.2rem;
  }

  .t4-text {
    font-size: 0.3rem;
    color: #fff;
    line-height: 1.6;
    text-align: left;
    width: 100%;
    font-weight: 400;
  }

  .t4-rules-title {
    font-size: 0.3rem;
    color: #e7c356;
    font-weight: 400;
    text-align: left;
    margin-bottom: 0.2rem;
  }

  .t4-rules {
    color: #fff;
    font-size: 0.3rem;
    font-weight: 400;
    line-height: 1.6;
    text-align: left;
  }

  .t4-rules p {
    margin: 0 0 0.1rem 0;
  }
}

// 底部推荐图
.t4-recommend {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 0.2rem;

  .t4-recommend-inner {
    display: flex;
    gap: 0.15rem;
    width: max-content;
    margin-top: 0.5rem;
  }

  .t4-recommend-item {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .t4-recommend-img {
    width: 2.5rem;
    border-radius: 0.1rem;
    flex-shrink: 0;
    object-fit: cover;
    border: 1px solid transparent;
    box-sizing: border-box;
  }

  .t4-recommend-item.t4-recommend-active .t4-recommend-img {
    border: 1px solid #d1ae52;
  }

  .t4-recommend-name {
    font-size: 0.26rem;
    color: #fff;
    margin-top: 0.1rem;
    text-align: center;
    max-width: 2.5rem;
    line-height: 1.3;
  }
}

// 弹框
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.popup-content {
  position: relative;
  width: 80%;
  max-width: 6rem;
  background: #1a1a1a;
  border-radius: 0.15rem;
  padding: 0.3rem;
}

.popup-close {
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
  width: 0.4rem;
  height: 0.4rem;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
  }
}

.popup-body {
  text-align: center;
}

.popup-img {
  width: 100%;
  border-radius: 0.1rem;
}

.popup-name {
  color: #fff;
  font-size: 0.3rem;
  margin-top: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/activityDetail/template4.vue